import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import DeleteButton from '../../shared/DeleteButton.js';
import './RanchCardList.css';

const RanchCard = ({ row, onDeleted }) => {
  const { t } = useTranslation();
  const [expanded, setExpanded] = useState(false);

  return (
    <div className={`ranch-card ${expanded ? 'expanded' : ''}`} onClick={() => setExpanded(e => !e)}>
      <div className="ranch-card-main">
        <div className="ranch-card-number">#{row.ranch_number}</div>
        <div className="ranch-card-name">{row.name || '—'}</div>
        <div className="ranch-card-chevron">{expanded ? '▲' : '▼'}</div>
        {row.address && (
          <div className="ranch-card-address">{row.address}</div>
        )}
      </div>

      {expanded && (
        <div className="ranch-card-detail" onClick={e => e.stopPropagation()}>
          <div className="ranch-card-detail-row">
            <span>{t('ranch_name')}</span>
            <span>{row.name || '—'}</span>
          </div>
          <div className="ranch-card-detail-row">
            <span>{t('address')}</span>
            <span>{row.address || '—'}</span>
          </div>
          <div className="ranch-card-detail-row">
            <span>{t('nickname')}</span>
            <span>{row.nickname || '—'}</span>
          </div>
          <div className="ranch-card-actions">
            <DeleteButton
              collection="ranches"
              data={[row]}
              onComplete={onDeleted}
              onError={() => {}}
            />
          </div>
        </div>
      )}
    </div>
  );
};

const RanchCardList = ({ data, onRefresh }) => {
  return (
    <div className="ranch-card-list">
      {data && data.map(row => (
        <RanchCard key={row._id} row={row} onDeleted={onRefresh} />
      ))}
      {(!data || data.length === 0) && (
        <div className="ranch-card-empty">—</div>
      )}
    </div>
  );
};

export default RanchCardList;
